import isPropValid from "@emotion/is-prop-valid";
import styled from "styled-components";
import { thumbHeight, thumbSize } from "./ThumbStyle";
export const TrackContainer = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  display: flex;
  align-items: center;
  height: ${thumbSize + thumbHeight}px;
  box-sizing: border-box;
  user-select: none;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhY2tDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TbGlkZXIvc3R5bGVkL1RyYWNrQ29udGFpbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBQ2pELE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxXQUFXLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBRXRELE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQztJQUNsRCxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBQTs7O1lBR1UsU0FBUyxHQUFHLFdBQVc7Ozs7Ozs7O0NBUWxDLENBQUMifQ==